import { color } from "minimum-ui/tokens";
import ReactSelect, { CSSObjectWithLabel, components } from "react-select";
import styled from "styled-components";

export type Option = {
  value: string;
  label: string;
};

export type OptionGroup = {
  label: string;
  options: Option[];
};

interface Props {
  placeholder?: string;
  value?: Option | null;
  options?: OptionGroup[];
  portalWidth?: string;
  onChange: (selectedOption: Option | null) => void;
}

export const Select: React.FC<Props> = (props) => {
  const {
    placeholder,
    value,
    options,
    portalWidth = "16rem",
    onChange,
  } = props;

  return (
    <StyledSelect
      tabIndex={0}
      placeholder={placeholder}
      value={value}
      options={options}
      components={{ ...customComponents }}
      styles={{
        ...customStyles,
        menuPortal: portalWidth
          ? (base) => ({
              ...base,
              zIndex: 100,
              width: `${portalWidth}`,
            })
          : undefined,
      }}
      onChange={(selectedOption) => {
        onChange(selectedOption as Option);
      }}
      menuPortalTarget={
        typeof window !== "undefined" ? document.body : undefined
      }
    />
  );
};

const customComponents = {
  GroupHeading: (props: any) => {
    const groupIndex = (props.selectProps.options as OptionGroup[]).findIndex(
      (group) => group.label === props.data.label
    );

    return (
      <>
        {groupIndex > 0 && <Separator />}
        <components.GroupHeading {...props} />
      </>
    );
  },
};

// This is duplicated as it lives in another package
export const commonStyles = {
  multiValue: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    backgroundColor: color.blue[100],
    color: color.blue[300],
    borderRadius: 20,
  }),
  multiValueLabel: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    color: color.blue[300],
    paddingLeft: 10,
    paddingRight: 0,
  }),
};

const customStyles = {
  ...commonStyles,
  control: (baseStyles: CSSObjectWithLabel) => ({
    ...baseStyles,
    border: `1px solid color.neutral[200]`,
    borderRadius: "8px",
    "&:hover": {
      borderColor: "none",
      cursor: "pointer",
    },
  }),
  indicatorSeparator: () => ({ display: "none" }),
  option: () => ({
    fontSize: "0.875rem",
    padding: "0.5rem 1rem",
    "&:hover": {
      backgroundColor: color.neutral[200],
    },
  }),
};

const StyledSelect = styled(ReactSelect)`
  flex: 1;
  font-size: 0.875rem;
`;

const Separator = styled.div`
  border-top: 1px solid color.neutral[200];
  width: 100%;
  height: 0.5rem;
`;
